import React, {
  useImperativeHandle,
  useRef,
  useState,
  forwardRef,
} from "react";
import { Modal } from "antd";

export type PdfModalRef = {
  showPdf: (url: string) => void;
  hide: () => void;
};

type PdfModalProps = {
  width?: number | string;
  height?: number | string;
  title?: string;
  onOk?: () => void; // opcional
  isLoading: boolean,
};

const PdfModal = forwardRef<PdfModalRef, PdfModalProps>(
  ({ width = "90vw", height = "70vh", title = "Documento PDF", onOk , isLoading}, ref) => {
    const [open, setOpen] = useState(false);
    const [pdfUrl, setPdfUrl] = useState<string>("");

    useImperativeHandle(ref, () => ({
      showPdf: (url: string) => {
        setPdfUrl(url);
        setOpen(true);
      },
      hide: () => setOpen(false),
    }));

    const handleOk = () => {
      if (onOk) onOk(); 
      setOpen(false);
    };

    return (
      <Modal
        okButtonProps={{loading: isLoading}}
        cancelButtonProps={{loading: isLoading}}
        open={open}
        title={title}
        onCancel={() => setOpen(false)}
        onOk={handleOk}
        okText="Emitir ahora"
        width={width}
        styles={{ body: { padding: 0 } }}
        destroyOnClose
      >
        {pdfUrl ? (
          <iframe
            key={pdfUrl}
            src={`${pdfUrl}#toolbar=1&navpanes=0`}
            style={{ width: "100%", height }}
            loading="lazy"
            allow="fullscreen"
          />
        ) : (
          <div style={{ padding: 24 }}>Cargando…</div>
        )}
      </Modal>
    );
  }
);

export default PdfModal;
